import { InstallExtensionFloating } from 'components/extension/InstallExtensionFloating'
import { isMobile } from 'react-device-detect'

export const NoneMemberTitle = (props: any) => {
  const { userInfo, isExtensionInstalled } = props
  return (
    <div className="flex flex-col items-center w-[343px] md:w-full">
      <div className="flex items-center md:flex-row flex-col gap-1 mb-2 md:relative w-full justify-center relative">
        <InstallExtensionFloating
          userInfo={userInfo}
          isExtensionInstalled={isExtensionInstalled}
        />{' '}
        <h1 className="font-bold text-[26px] md:text-[40px]">
          클릭 한 번에 상품 리뷰 영상 생성!
        </h1>
        <a
          className="flex gap-2 items-center md:absolute md:right-0 md:top-[25%]"
          href="https://angelleague.notion.site/AI-15bba20e97f3809b8d33d7b08aaacd3f"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="assets/img/icon_youtube.png"
            alt="youtube"
            width={26}
            height={26}
          />{' '}
          <span className="font-bold">{`샘플 보기 >`}</span>
        </a>
      </div>
      <div className="">
        <p className="flex justify-center items-center gap-[4px]">
          <img
            src="assets/img/coupang_icon.png"
            alt="coupang"
            width={17.76}
            height={17.42}
          />
          <img
            src="assets/img/naver_icon.png"
            alt="ali"
            width={17.76}
            height={17.42}
          />
          <img
            src="assets/img/ali_icon.png"
            alt="ali"
            width={17.76}
            height={17.42}
          />
          상품만 고르면,
        </p>
        {isMobile ? (
          <>
            <div className="flex flex-col items-center">
              <p className="">
                <span className='text-main font-bold"'>FASTCUT이</span>
                나레이션, 편집, BGM 넣은
              </p>
              <p>영상을 내 채널에 등록까지 해줘요</p>
            </div>
          </>
        ) : (
          <>
            <div className="flex justify-center">
              <p className="text-main font-bold">FASTCUT이</p>
              <p>나레이션, 편집, BGM 넣은 영상을 내 채널에 등록까지 해줘요</p>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
